import * as React from 'react';
import { useColorMode, useColorModeValue, Box, Tooltip, IconButton, IconButtonProps } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faSun } from '@fortawesome/pro-regular-svg-icons';

type ThemeSwitcherProps = Omit<IconButtonProps, 'aria-label'>;

export const ThemeSwitcher: React.FC<ThemeSwitcherProps> = () => {
  const { toggleColorMode } = useColorMode();
  const text = useColorModeValue('dark', 'light');
  const switchIcon = useColorModeValue(faMoon, faSun);

  return (
    <Box display="flex" justifyContent="center">
      <Tooltip hasArrow placement="right" label={`Use ${text} theme`}>
        <IconButton
          aria-label={`Use ${text} theme`}
          onClick={toggleColorMode}
          icon={<FontAwesomeIcon icon={switchIcon} size="lg" fixedWidth />}
          variant="ghost"
          colorScheme="whiteAlpha"
          color="whiteAlpha.600"
          position="absolute"
          top={1}
          right={1}
          _dark={{ color: 'whiteAlpha.600' }}
        />
      </Tooltip>
    </Box>
  );
};
